import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import axios from "axios";

const RecentColleges = ({ tag }) => {
  const router = useRouter();
  const [recentColleges, setRecentColleges] = useState([]);

  const fetchRecentColleges = async (tag) => {
    const baseURL = process.env.NEXT_PUBLIC_GHOST_API_URL;
    const apiKey = process.env.NEXT_PUBLIC_GHOST_API_KEY;
    try {
      const res = await axios.get(
        `${baseURL}/ghost/api/v3/content/posts/?key=${apiKey}&filter=tag:${tag}&limit=5`
      );
      setRecentColleges(res.data.posts);
    } catch (error) {
      console.error("Error fetching recent colleges:", error);
    }
  };

  useEffect(() => {
    if (tag) {
      fetchRecentColleges(tag);
    }
  }, [tag]);

  return (
    <div className="mt-12 px-5">
      <h2 className="text-xl font-bold mb-6">Recent Posts</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {recentColleges.map((post) => (
          <div key={post.id} className="p-2">
            <div
              className="border rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer h-[320px] flex flex-col overflow-hidden"
              onClick={() => router.push(`/blogs/${post.slug}`)}
            >
              {/* Image Section */}
              <div className="h-[70%] w-full relative overflow-hidden">
                <img
                  src={
                    post.feature_image
                      ? post.feature_image.replace("ghost.", "")
                      : "/default-image.jpg"
                  }
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content Section */}
              <div className="p-4 flex flex-col justify-between flex-1 overflow-hidden">
                <h3
                  className="text-lg font-semibold truncate"
                  title={post.title}
                >
                  {post.title}
                </h3>

                <div className="mt-4 text-[#ff9245] text-sm font-semibold flex items-center">
                  View Details
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-2 h-4 w-4 text-[#ff9245]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentColleges;
